<template>
  <div>
    <iframe
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/team/presence-talent`"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      height: 0,
    }
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
  },
  destroyed() {
    window.removeEventListener('message', this.watchIframe)
  },
  methods: {
    watchIframe(event) {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const { type, data } = event.data

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }

        if (type === 'ERR_DOWNLOAD_PRESENCE') {
          this.$toast_error({ message: 'Gagal mengunduh data kehadiran' })
        }
      }
    },
  },
}
</script>
